<template>
  <div class="mb-4">
    <label for="cellNumber" class="text-black text-sm mb-2">{{ props.label }}</label>
    <div class="input-group mt-2">
      <input
        v-model="cellNumber"
        type="text"
        placeholder="Enter mobile number"
        required
        class="border placeholder:text-gray-600 rounded w-full py-2 px-3 text-gray-700 leading-tight"
        data-testid="mobile"
        @change="onChange"
        @keypress="onlyNumberKey($event)"
        :disabled="props.disabled"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onlyNumberKey, parseMobile } from '@/utils/form.utils';
import { ref } from 'vue';

const props = defineProps<{
  label: string;
  disabled?: boolean;
}>();

const cellNumber = ref('');

const emit = defineEmits(['update:modelValue']);

const onChange = (event: any) => {
  emit('update:modelValue', parseMobile(event.target.value));
};
</script>
